import { BaseAPI } from "@/api/base.api";
import { Node, NodeModel } from "@/models/node";
import { VUE_APP_SIT_API_URL, API_URL_SERVICE } from "@/commons/config";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import { AutorizacaoFretamento } from "@/models/autorizacaoFretamento";
import { Taxa } from "@/models/taxa";

export class LicencaEspecialAPI extends BaseAPI<AutorizacaoFretamento> {
  constructor() {
    super();
    this.apiUrl = `${VUE_APP_SIT_API_URL}`;
  }

  public doLogin(
    cnpj: string,
    recaptcha: string,
    placa: string
  ): AxiosObservable<any> {
    placa = placa.replace("-", "");

    return this.axios
      .post(`${this.apiUrl}/autorizacoesFretamento/validaLogin`, {
        cnpj: cnpj,
        recaptcha,
        placa: placa
      })
      .pipe(
        map((res: any) => {
          const { validaLogin, mensagemNegocio } = res;

          if (!validaLogin) {
            throw mensagemNegocio;
          }

          return validaLogin;
        })
      );
  }

  public criarAutorizacaoFretamento(
    veiculoTransportadoraId: number,
    taxaId: number
  ): AxiosObservable<AutorizacaoFretamento[]> {
    return this.axios
      .post(`${this.apiUrl}/autorizacoesFretamento/geraAutorizacao`, {
        veiculoTransportadoraId,
        taxaId
      })
      .pipe(
        map((res: any) => {
          const { autorizacaoFretamentoDTO, mensagemNegocio } = res;

          if (!autorizacaoFretamentoDTO) {
            throw mensagemNegocio;
          }

          return autorizacaoFretamentoDTO;
        })
      );
  }

  public listarTodasAutorizacoesFretamento(
    veiculoTransportadoraId: number
  ): AxiosObservable<AutorizacaoFretamento[]> {
    return this.axios
      .post(`${this.apiUrl}/autorizacoesFretamento/autorizacoesFretamento`, {
        veiculoTransportadoraId
      })
      .pipe(
        map((res: any) => {
          const { autorizacoesFretamento, mensagemNegocio } = res;

          if (!autorizacoesFretamento || !autorizacoesFretamento.length) {
            throw mensagemNegocio;
          }

          return autorizacoesFretamento;
        })
      );
  }

  public removerAutorizacaoFretamento(
    autorizacaoFretamento: AutorizacaoFretamento
  ): AxiosObservable<AutorizacaoFretamento[]> {
    return this.axios.post(
      `${this.apiUrl}/autorizacoesFretamento/removerLicenca`,
      { autorizacaoFretamento }
    );
  }

  public listarTodasTaxasFretamento(
    veiculoTransportadoraId: number
  ): AxiosObservable<Taxa[]> {
    return this.axios
      .post(`${this.apiUrl}/autorizacoesFretamento/taxasFretamento`, {
        veiculoTransportadoraId
      })
      .pipe(
        map((res: any) => {
          const { taxas, mensagemNegocio } = res;

          if (!taxas || !taxas.length) {
            throw mensagemNegocio;
          }

          let taxasResult = taxas.map((element: any) => {
            return {
              codigoFinanceiro: element.codigoFinanceiro,
              descricao: element.descricao,
              valorTaxa: element.valorTaxa,
              placaObrigatoria: element.placaObrigatoria,
              validaIdade: element.validaIdade,
              id: element.id,
              descricaoFormatado: `${element.descricao.toUpperCase()} - ${Intl.NumberFormat(
                "pt-BR",
                {
                  style: "currency",
                  currency: "BRL"
                }
              ).format(element.valorTaxa)}`
            };
          });

          return taxasResult.sort((a: any, b: any) =>
            a.valorTaxa > b.valorTaxa ? 1 : -1
          );
        })
      );
  }
  public imprimirLicençaViagem(viagemId: number): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/autorizacoesFretamento/imprimirLicencaViagem`,
      { viagemId }
    );
  }

  public findAutorizacaoById(
    id: number
  ): AxiosObservable<AutorizacaoFretamento> {
    return this.axios.post(`${API_URL_SERVICE}/api/licenca/autorizacao`, {
      id
    });
  }
}
